module.exports = __webpack_public_path__ + "img/qr.4c828820.jpg";